/**
 * @desc 更新sku物流信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ViewLogisticsSkuUpdateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/logisticsSku/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
